import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.object.assign.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { make } from 'vuex-pathify';
import { i18n } from '@/boot/i18n';

var defaultState = function defaultState() {
  return {
    error: null,
    queue: []
  };
};

var state = defaultState();

var getters = _objectSpread({}, make.getters(state));

var mutations = {
  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Set current error message in state.
   *
   * @param {Object} state Vuex module state
   * @param {Object} error Error object
   * @param {Boolean} error.big Makes the modal big (optional)
   * @param {Boolean} error.closeButton Display the close button (optional)
   * @param {String} error.color Modal default colour (optional)
   * @param {String} error.error Error message (required)
   * @param {String} error.icon Icon displayed above the modal text (optional)
   * @param {String} error.iconColor Icon colour (optional)
   * @param {Boolean} error.okButton Display the OK button (optional)
   * @param {String} error.okButtonText OK button text(optional)
   * @param {String} error.textColor Text colour (optional)
   * @param {String} error.titleColor Title colour (optional)
   * @param {String} error.title Title string (optional)
   * @param {String} error.noteColor Note colour (optional)
   * @param {String} error.note Note string (optional)
   *
   * @returns {Void}
   */
  setError: function setError(state, error) {
    return state.error = error;
  },

  /**
   * Add an error to the queue.
   *
   * @param {Object} state Vuex module state
   * @param {Object} error Error object
   * @param {Boolean} error.big Makes the modal big (optional)
   * @param {Boolean} error.closeButton Display the close button (optional)
   * @param {String} error.color Modal default colour (optional)
   * @param {String} error.error Error message (required)
   * @param {String} error.icon Icon displayed above the modal text (optional)
   * @param {String} error.iconColor Icon colour (optional)
   * @param {Boolean} error.okButton Display the OK button (optional)
   * @param {String} error.okButtonText OK button text(optional)
   * @param {String} error.textColor Text colour (optional)
   * @param {String} error.titleColor Title colour (optional)
   * @param {String} error.title Title string (optional)
   * @param {String} error.noteColor Note colour (optional)
   * @param {String} error.note Note string (optional)
   *
   * @returns {Void}
   */
  addToQueue: function addToQueue(state, error) {
    return state.queue.push(error);
  },

  /**
   * Set error with element from queue.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  setErrorFromQueue: function setErrorFromQueue(state) {
    return state.error = state.queue.shift();
  },

  /**
   * Clear the current queue.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  clearQueue: function clearQueue(state) {
    return state.queue = [];
  }
};
var actions = {
  /**
   * Prepare and display an error message to the user.
   *
   * @param {Object} context Vuex module context
   * @param {Object} error Error object
   * @param {Boolean} error.big Makes the modal big (optional)
   * @param {Boolean} error.closeButton Display the close button (optional)
   * @param {String} error.color Modal default colour (optional)
   * @param {String} error.error Error message (required)
   * @param {String} error.icon Icon displayed above the modal text (optional)
   * @param {String} error.iconColor Icon colour (optional)
   * @param {Boolean} error.okButton Display the OK button (optional)
   * @param {String} error.okButtonText OK button text(optional)
   * @param {String} error.textColor Text colour (optional)
   * @param {String} error.titleColor Title colour (optional)
   * @param {String} error.title Title string (optional)
   * @param {String} error.noteColor Note colour (optional)
   * @param {String} error.note Note string (optional)
   * @param {Object} error.trace A compact, standard format trace object. (optional)
   *
   * @returns {Void}
   */
  display: function display(context, error) {
    // Serialize & set trace if provided
    var trace = error.trace ? stringifyTrace(error.trace) : null;

    if (trace) {
      error.note = i18n.tc('error.trace', trace);
    } // Set the error or enqueue it if there's already an error in place


    if (!context.state.error) {
      context.commit('setError', error);
    } else {
      context.commit('addToQueue', error);
    }
  },

  /**
   * Clear global error in state.
   *
   * @param {Object} state Vuex module context
   *
   * @returns {Void}
   */
  clearError: function clearError(context) {
    if (context.state.queue.length) {
      context.commit('setError', null);
      setTimeout(function () {
        return context.commit('setErrorFromQueue');
      }, 200);
    } else {
      context.commit('setError', null);
    }
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};
/**
 * Generate a compact, fairly opaque string based trace capturing any information that has been provided.
 *
 * @param {Object} trace Standardized trace object
 * @param {String} trace.type Trace type
 * @param {Object} trace.payload Trace payload, with compact, opaque keys
 *
 * @returns {String}
 */

var stringifyTrace = function stringifyTrace(t) {
  return [t === null || t === void 0 ? void 0 : t.type, t === null || t === void 0 ? void 0 : t.value].join('/') || null;
};